var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78647 4.36983C2.78647 1.96318 4.74987 0 7.1563 0C9.56273 0 11.5261 1.96318 11.5261 4.36983C11.5261 6.77632 9.56273 8.70789 7.1563 8.70789C4.74987 8.70789 2.78647 6.74471 2.78647 4.36983ZM14.3125 17.0042C14.2491 13.2678 11.241 10.1962 7.50456 10.0062C5.54138 9.91123 3.64142 10.6079 2.2165 11.9694C0.791571 13.3309 0 15.1675 0 17.1625C0 18.1758 0.855014 18.999 1.86818 18.999H12.4443C12.951 18.999 13.4259 18.8091 13.7742 18.4607C14.1226 18.1124 14.3125 17.6375 14.3125 17.1624L14.3125 17.0042Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.8bcf36fa89474bea035d27fe018e95a1.svg";
export { ForwardRef as ReactComponent };